import type { JiraHomeRouteResourceData } from '@atlassian/jira-home/src/common/types/route-resource.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import {
	RESOURCE_TYPE_JIRA_HOME,
	RESOURCE_TYPE_JIRA_HOME_PROJECT_REC_EXPERIMENT,
} from './constants.tsx';

export const jiraHomeResourceWithCache: RouteResource<JiraHomeRouteResourceData | null> =
	resourceWithCondition(
		() => expVal('recommended_projects_for_you_page', 'isEnabled', false),
		createResource<JiraHomeRouteResourceData | null>({
			type: RESOURCE_TYPE_JIRA_HOME_PROJECT_REC_EXPERIMENT,
			getKey: () => 'jira-home-2',
			getDataLoader: () =>
				import(
					/* webpackChunkName: "async-resource-jira-home-with-cache-2", jiraSpaEntry: "async-resource-jira-home-2" */ './controllers/get-data-experiment'
				),
			maxAge: Infinity,
		}),
		createResource<JiraHomeRouteResourceData | null>({
			type: RESOURCE_TYPE_JIRA_HOME,
			getKey: () => 'jira-home',
			getDataLoader: () =>
				import(
					/* webpackChunkName: "async-resource-jira-home-with-cache", jiraSpaEntry: "async-resource-jira-home" */ './controllers/get-data'
				),
			maxAge: Infinity,
		}),
	);
